import React from 'react'
//hook for checking if an el is in viewport
import useIsInViewport from 'use-is-in-viewport'

function Flatiron() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="Flatiron">
				<br/>
				<h2>Flatiron School</h2>
				<h5>Febuary 2020 - June 2020</h5>
				<h5>New York, New York</h5>
				<h4>Software Engineering Program</h4>
				<div className="divider"></div>
				<b>Programming Fundamentals</b>
				<p>- After diving into the fundamentals of programming, students get comfortable with object-oriented programming and storing databases using SQL and Object Relational Mappers.</p>
				<b>Web Frameworks </b>
				<p>- Students learn two key Ruby frameworks, first mastering the fundamentals of web programming with Sinatra before experiencing how quickly they can build incredible apps with Rails.</p>
				<b>Javascript</b>
				<p>- Students gain a thorough understanding of Javascript, crucial for front-end developers.</p>
				<b>Front-end Frameworks</b>
				<p>- Students learn to build productive, scalable front-ends with React and Redux, creating slick, functional, reactive code with Rails as the back-end JSON API.</p>
				<b>Solo Projects</b>
				<p>- After completing four curriculum modules focused on group projects, students work with instructors to come up with solo project concepts and spend three full weeks building truly sophisticated applications on their own.<br/> <br/>
				</p>
			</div>
		</div>
	  )
}

export default Flatiron